// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PieChartTwoToneSvg from "@fishx/icons-svg/es/asn/PieChartTwoTone";
import FishxIcon from '../components/FishxIcon';

var PieChartTwoTone = function PieChartTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PieChartTwoToneSvg
  }));
};

PieChartTwoTone.displayName = 'PieChartTwoTone';
export default React.forwardRef(PieChartTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PieChartTwoTone.js
// module id = 3791
// module chunks = 0